(function () {
    'use strict';

    angular
        .module('app')
        .controller('contactformController', contactFormController);

    contactFormController.$inject = ['$scope', 'contactService'];
    function contactFormController($scope, contactService) {
        /* jshint validthis:true */
        var vm = this;
        vm.user = {
            name: '',
            email: '',
            phone: '',
            organization: '',
            messageFromSender: '',
            pageLink: ''
        };
        vm.formSubmitted = false;
        vm.inProgress = false;
        vm.errorMsg = '';

        vm.init = init;
        vm.submitContactForm = submitContactForm;

        function init(pl) {
            vm.user.pageLink = pl;
        }

        function submitContactForm() {
            vm.errorMsg = '';
            vm.formSubmitted = false;
            vm.inProgress = true;
            contactService.send(vm.user, function (result) {
                if (result === true) {
                    vm.formSubmitted = true;
                    vm.user = {
                        name: '',
                        email: '',
                        phone: '',
                        organization: '',
                        messageFromSender: '',
                        pageLink: vm.user.pageLink
                    };
                } else {
                    vm.errorMsg = 'error';
                }
                ga('send', 'event', 'ProdukterTjansterFormular', 'SUBMIT', vm.user.pageLink);
            }, function (err) {
                vm.errorMsg = 'error';
            }).then(function () {
                //do nothing, this is handled by success/error functions
            }).then(function () {
                //hide loading/in-progress symbol
                vm.inProgress = false;
            });
        }
    }
})();
